import React, { useEffect, useRef } from "react";
import { Progress } from "semantic-ui-react";
import Constants from "constants/Constants";
import styles from "./JobProgress.module.scss";

const { DATA_JOB_STATUSES } = Constants;

const IGNORE_STATUSES = [
  DATA_JOB_STATUSES.COMPLETE,
  DATA_JOB_STATUSES.FAILED,
  DATA_JOB_STATUSES.ABORTED,
  DATA_JOB_STATUSES.EXPIRED,
  DATA_JOB_STATUSES.READY,
];
const HUNDRED_PERCENT = 100;
const FIFTY_PERCENT = 50;
const MONITOR_INTERVAL = 3000;

const STATUS_COLORS = {
  success: "green",
  danger: "red",
  default: "blue",
};

function getProgress(progress) {
  if (!progress?.max_rows || !progress?.current_row) {
    return null;
  }
  return Math.floor((progress.current_row / progress.max_rows) * 100);
}

function getCurrentProgress(info) {
  const validation = info?.validation;
  const importing = info?.import;
  let percentage = 0;

  if (importing) {
    percentage = getProgress(importing);
  } else if (validation) {
    percentage = getProgress(validation);
  }

  return Math.floor(percentage);
}

export function JobProgress({
  jobId,
  info,
  status,
  invalidateData,
  getMonitorJobProgress,
}) {
  const monitorInterval = useRef(null);

  useEffect(() => {
    if (!IGNORE_STATUSES.includes(status)) {
      if (!!monitorInterval.current) {
        clearInterval(monitorInterval.current);
        monitorInterval.current = null;
      } else if (!monitorInterval.current) {
        monitorInterval.current = setInterval(
          () =>
            getMonitorJobProgress({ jobId, status, callback: invalidateData }),
          MONITOR_INTERVAL
        );
      }
    }

    return () => {
      if (!!monitorInterval.current) {
        clearInterval(monitorInterval.current);
        monitorInterval.current = null;
      }
    };
  }, [jobId, status, getMonitorJobProgress, invalidateData]);

  function jobHasError() {
    return (
      status === DATA_JOB_STATUSES.FAILED ||
      status === DATA_JOB_STATUSES.ABORTED ||
      status === DATA_JOB_STATUSES.EXPIRED
    );
  }

  function getProgressColor() {
    if (jobHasError()) {
      return STATUS_COLORS.danger;
    }
    if (status === DATA_JOB_STATUSES.COMPLETE) {
      return STATUS_COLORS.success;
    }
    return STATUS_COLORS.default;
  }

  function getProgressPercent() {
    if (IGNORE_STATUSES.includes(status)) {
      return HUNDRED_PERCENT;
    }

    if (!!info?.is_import) {
      return getCurrentProgress(info);
    }

    if (status === DATA_JOB_STATUSES.IN_PROGRESS) {
      return FIFTY_PERCENT;
    }

    return getCurrentProgress(info);
  }

  return (
    <div className={styles["job-progress-wrapper"]}>
      <Progress
        percent={getProgressPercent()}
        error={jobHasError()}
        color={getProgressColor()}
        active={status === DATA_JOB_STATUSES.IN_PROGRESS}
        progress
      />
    </div>
  );
}
